export const DEFAULT_PROMO_VARIANT = 'default-promo-banner';
export const SECONDARY_PROMO_VARIANT = 'secondary-promo-banner';
